import { gql, useApolloClient } from '@apollo/client';
import {
  GetOrphansQuery,
  GetOrphansQueryVariables,
} from '../../__generated__/queries-web';

const SEARCH_ORPHAN_PAGES = gql`
  query GetOrphans(
    $where: OrphanPageFilterInput
    $first: UnsignedInt!
    $skip: UnsignedInt!
  ) {
    orphanPages(
      first: $first
      where: $where
      orderBy: publishedAt_DESC
      skip: $skip
    ) {
      id
      publishedAt
      editedAt
      status
      title
      metas
      isCMPEnabled
      isFullScreen
      brandKey
      uri
      __typename
    }
  }
`;

export const useSearchOrphanPageGetter = () => {
  const client = useApolloClient();

  return (variables: GetOrphansQueryVariables) =>
    client.query<GetOrphansQuery, GetOrphansQueryVariables>({
      query: SEARCH_ORPHAN_PAGES,
      variables,
      fetchPolicy: 'network-only',
    });
};
